import FlexBox from '@/atomic-components/FlexBox';
import { Box, Skeleton, Typography } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { getColor } from '@/utils/theme/colors';
import { Breakup, VerticalCartSummary } from '@/services/cart/models/cart';
import { generateBlockOfBreakup, reduceStyle } from './utils';
import { getStyle } from '@/utils/theme/fonts';
import DropdownArrow from '@/assets/cart/DropDownIcon.svg';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import {
	SpecTab,
	MeasurementTab,
} from '../ProductDisplayPage/Components/Inclusions/measurementUnitSelectionSwitch';
import { useState } from 'react';
import { dataLayerPushWithEvent } from '@/utils/dataLayer';

export enum PAYMENT_BREAKUP_VIEW_OPTIONS {
	PAYMENT_BREAKUP_SUMMARY = 'SUMMARY',
	PAYMENT_BREAKUP_DETAILS = 'DETAILS',
}

type VerticalCartBreakupProps = {
	titleDetails?: Breakup;
	cartItemsDetails?: VerticalCartSummary;
	context: string;
};

export function VerticalCartBreakupShimmer() {
	return (
		<Box
			p='28px 32px'
			sx={{
				background: getColor('Gray -6'),
				borderRadius: '8px',
			}}
			className='cursor-pointer'
		>
			<FlexBox justifyContent={'space-between'}>
				<Skeleton width='60%' />
				<Skeleton variant='circular' width='30px' height='30px' />
			</FlexBox>
			<FlexBox justifyContent={'space-between'}>
				<Skeleton width='40%' />
				<Skeleton width='40%' />
			</FlexBox>
			<LencoTypography
				variant='Small_Medium'
				color={getColor('Success +1')}
				mt='12px'
			>
				<Skeleton width={'100%'} />
			</LencoTypography>
		</Box>
	);
}

const Header = ({ titleDetails }: { titleDetails?: Breakup }) => (
	<Box
		p='0px 24px'
		pt='24px'
		sx={{ backgroundColor: titleDetails?.backgroundColor }}
	>
		<LencoTypography sx={reduceStyle(titleDetails?.titleBlock?.styles!)}>
			{titleDetails?.titleBlock?.value}
		</LencoTypography>
		{/* <RightArrowMinty /> */}
	</Box>
);

const CartItemsCostBreakup = ({
	cartItemsDetails,
	vertical,
	paymentBreakUpView,
}: {
	cartItemsDetails?: VerticalCartSummary;
	vertical?: string;
	paymentBreakUpView?: Boolean;
}) => (
	<Box sx={{ borderRadius: '8px' }}>
		{paymentBreakUpView === false &&
			cartItemsDetails?.breakupSummaryItemBlocks?.map((item) => {
				return item.map((block: Breakup) => {
					return generateBlockOfBreakup(block);
				});
			})}
		{paymentBreakUpView === true &&
			cartItemsDetails?.breakupDetailedItemBlocks?.map((item) => {
				return item.map((block: Breakup) => {
					return generateBlockOfBreakup(block);
				});
			})}
	</Box>
);

export const VerticalCartBreakup = (props: VerticalCartBreakupProps) => {
	const { titleDetails, cartItemsDetails } = props;

	const [expandedFaq, setExpandedFaq] = useState<Boolean>(false);
	return (
		<Box
			sx={{
				borderRadius: '8px',
				overflow: 'hidden',

				boxShadow: '0px 8px 8px 0px rgba(34, 34, 34, 0.05)',
				background:
					cartItemsDetails?.breakupDetailedTitleHeader?.backgroundColor,
			}}
		>
			<Accordion
				expanded={expandedFaq === true}
				onChange={() => setExpandedFaq(!expandedFaq)}
				sx={{
					margin: '0px',
					minHeight: '0px',

					background:
						cartItemsDetails?.breakupDetailedTitleHeader?.backgroundColor,
				}}
			>
				<AccordionSummary
					sx={{
						padding: '0px 10px',
						m: 0,
					}}
				>
					<FlexBox direction='column' gap='4px' width='100%'>
						<FlexBox
							width='100%'
							justifyContent='space-between'
							alignItems='center'
						>
							<Typography
								sx={{
									...getStyle(
										`${cartItemsDetails?.breakupDetailedTitleHeader?.titleBlock?.styles?.fontSizeWeight}`
									),
									color:
										cartItemsDetails?.breakupDetailedTitleHeader?.titleBlock
											?.styles?.color,
									textDecoration: cartItemsDetails?.breakupDetailedTitleHeader
										?.titleBlock?.styles?.isUnderLined
										? 'underline'
										: cartItemsDetails?.breakupDetailedTitleHeader?.titleBlock
												?.styles?.strikedThrough
										? 'line-through'
										: 'none',
									whiteSpace: 'nowrap',
								}}
								// ref={props?.refs?.paymentBreakupRef}
							>
								{
									cartItemsDetails?.breakupDetailedTitleHeader?.titleBlock
										?.value
								}
							</Typography>

							<FlexBox
								alignItems='center'
								justifyContent='center'
								sx={{
									padding: '6px 12px',
									borderRadius: '13px',
									border: `1px solid ${getColor('Minty 0')}`,
									cursor: 'pointer',
								}}
							>
								<LencoTypography
									sx={{
										...getStyle('Tiny_Regular'),
										color: getColor('Minty 0'),
									}}
								>
									{expandedFaq === true ? 'Hide Breakup' : 'View Breakup'}
								</LencoTypography>
								<FlexBox
									sx={{
										ml: '8px',
										alignItems: 'center',

										transform:
											expandedFaq === true ? 'rotate(180deg)' : 'rotate(0deg)',
									}}
								>
									<DropdownArrow />
								</FlexBox>
							</FlexBox>
						</FlexBox>
						{expandedFaq === false && (
							<CartItemsCostBreakup
								cartItemsDetails={cartItemsDetails}
								vertical='rent'
								paymentBreakUpView={expandedFaq}
							/>
						)}
					</FlexBox>
				</AccordionSummary>
				<AccordionDetails sx={{ p: 0, mt: 0 }}>
					<CartItemsCostBreakup
						cartItemsDetails={cartItemsDetails}
						vertical='rent'
						paymentBreakUpView={expandedFaq}
					/>
				</AccordionDetails>
			</Accordion>
		</Box>
	);
};

export default VerticalCartBreakup;
